// ============================================================
// HeaderPortalContext
// Layout B — the full-width topbar. App.tsx renders a single topbar
// container at the very top of the app shell and provides its DOM node
// here. Each authenticated screen still renders its own <AppHeader …>
// with its own per-screen props (back button, wordmark handler, action
// buttons, hideBottomBorder) — but AppHeader portals its <nav> into this
// shared container so the header spans the FULL width across the top,
// above both the Sidebar and the content (the L-shape). Only one screen
// (hence one AppHeader) is mounted at a time, so there's never a double
// header. When the context is null (no container yet / any non-shell
// caller), AppHeader falls back to rendering inline, so it stays
// backward-compatible.
// ============================================================
import { createContext } from 'react'

export const HeaderPortalContext = createContext<HTMLElement | null>(null)
